import React from 'react'
import { Button, Typography } from 'antd'
import { Fade } from 'react-awesome-reveal'
import './FinalCTA.css'
import { isMobile } from 'react-device-detect'
import { translate } from '../../../cls/TranslationContext'
import { useNavigate } from 'react-router-dom'
const { Title, Paragraph } = Typography

const FinalCTA = () => {
	const navigate = useNavigate()
	return (
		<div className="final-cta-container">
			<Fade triggerOnce cascade damping={0.2}>
				<div
					className="final-cta-content"
					style={isMobile ? { textAlign: 'left' } : {}}
				>
					<Title level={2} className="final-cta-title">
						{translate('home.finalTitle')}
					</Title>
					<Paragraph className="final-cta-subtitle">
						{translate('home.finalDesc')}
					</Paragraph>
					<Button
						onClick={() => {
							navigate('/signup')
						}}
						type="primary"
						size="large"
					>
						{translate('home.finalBtn')}
					</Button>
				</div>
			</Fade>
		</div>
	)
}

export default FinalCTA
